export { default as RegistryProvider, RegistryConsumer } from './context';
export { default as useRegistry } from './use-registry';
//# sourceMappingURL=index.js.map